import { create } from "zustand";
import axios from "../helper/axios";

const useProjectStore = create((set, get) => ({
    isModalOpenP: false,
    currentProjects:null,
    groupnamelist: null,
    projectUpdateFlag: false,

    setModalOpenP: () => {
        set({ isModalOpenP: true });
    },
    handleModalPOk: () => {
        set({ isModalOpenP: false });
    },
    handleModalPCancel: () => {
        set({ isModalOpenP: false });
    },
    handleProjectAdd: async (value) => {
        try {
            console.log("Set New Project",value)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/addProject/${userData.qhoid}/${userData.qhuid}/${userData.username}/${value}`
            );
            set({ projectUpdateFlag: true }); 
        } catch (err) {
            console.log(err);
        }
    },
    removeProject: async (value) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/removeProject/${userData.qhoid}/${userData.qhuid}/${userData.username}/${value}`
            );
            set({ projectUpdateFlag: true }); 
        } catch (err) {
            console.error(err);
        }
    },
    resetProjectUpdate: () => {
        set({ projectUpdateFlag: false });
    },

    getProjects: async (value) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getProjects/${userData.qhoid}/${userData.qhuid}/${userData.username}`
            );
            console.log("Fetched Projects:", response.data);
            set({ currentProjects: response.data.data }); 
            set({ groupnamelist: response.data.groupnamelist });
        } catch (err) {
            console.log(err);
        }
    },
}));

export default useProjectStore;
